import React from "react";
import styles from "./Footer.module.scss";
import { F_Open_Sans } from "@/fonts";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className={`${F_Open_Sans.className} ${styles.footer}`}>
      © Copyright {currentYear}. Made by Jasmina Mihajloska
    </div>
  );
};

export default Footer;
